<template>
  <div class="devicesList">
    <!-- Title and Header -->
    <div class="devicesList__top">
      <div class="devicesList__top__title">
        <h2 class="medium-title">
          All Devices
           <span class="span" @click.stop="goToAddNew" >Add New</span>
        </h2>
      </div>
    </div>
    <div class="devicesList__header">
      <div class="devicesList__header__left">
        <div class="devicesList__header__left__status">
          <adx-dropdown-search @selected="selectedLocation" :list="locations" labelButton="Location" :selected-value="selectedLocationValue"/>
        </div>
        <div class="devicesList__header__left__status">
          <adx-dropdown-list :labelButton="selectedStatusLabel?selectedStatusLabel:`Status`" :valueDisplay="selectedStatusValue" :list="statusList" @selected="selectStatus" />
        </div>
        <div class="devicesList__header__left__status">
          <adx-dropdown-list :labelButton="selectedConditionLabel?selectedConditionLabel:`Condition`" :valueDisplay="selectedConditionValue" :list="conditionList" @selected="selectCondition" />
        </div>
        <div class="devicesList__header__left__status">
          <adx-dropdown-list :labelButton="`Photo`" :valueDisplay="selectedPhotoValue" :list="photoList" @selected="selectPhoto" />
        </div>
        <div v-if="filtered" class="reset">
          <button class="btn-regular primary" @click="resetFilter">Reset</button>
        </div>
      </div>
      <div class="devicesList__header__right">
        <p>Sort by :</p>
        <div>
          <adx-dropdown-sort  :labelButton="`All Filter`"
           :value.sync="selectedSortValue" :type="true" :options="sort"></adx-dropdown-sort>
        </div>
      </div>
    </div>
    <div class="devicesList__search">
        <i class="adx-ic_search"></i>
        <input type="text" placeholder="Search device location" class="search" v-model="searchBoxValue">
      </div>
    <!-- devicesList -->
    <div class="devicesList__content">
      <div>
        <table>
          <thead class="none">
            <tr>
              <td class="header subhead">ID</td>
              <td class="header subhead">Devices</td>
              <td class="header subhead">Price/slot</td>
              <td class="header subhead">Orientation</td>
              <td class="header subhead">Active</td>
              <td class="header subhead">Photo</td>
              <td class="header subhead">Public</td>
            </tr>
          </thead>
          <tbody v-if="!isLoading && !isEmpty">
            <tr v-for="(item, index) in items" :key="index" class="content">
              <td class="ID subhead">
               <span :class="['strong']" @click.stop="goToEdit({item})"> {{item.pub_id}}</span>
              </td>
              <td class="devices subhead" > 
                <div>{{item.location_name}}, {{item.placement}}</div>
                <div class="action">
                  <span @click.stop="goToEdit({item})">Edit</span>
                  <span class="firstbtn"  @click.stop="duplicateDevices({item})">Duplicate</span>
                </div>
              </td>
              <td class="right priceslot subhead"> {{item.price | formatMoney}} </td>
              <td class="position orientation subhead">{{ item.orientation }}</td>
              <td class="position active subhead">
                <div v-if= item.is_active>V</div><div v-else>-</div></td>
              <td class="position photo subhead">
                <div v-if= item.primary_photo>V</div><div v-else>-</div></td>
              <td class="position public subhead">
                <div v-if= item.is_public>V</div><div v-else>-</div></td>
            </tr>
          </tbody>
        </table>
        <!-- Pagination -->
        <div class="pagination" v-if="!isLoading && !isEmpty"><adx-pagination :selectedPage="selectedPage" 
        :maxPage="maxPage" @change-page="selectPage"/></div>
        <!-- Loading State -->
        <div class="loadingState"><adx-loading v-if="isLoading" slot="loading" /></div>
        <!-- Empty State -->
        <div class="emptyState"><adx-empty-selection v-if="isEmpty && !isLoading" /></div>
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from '@/components/SideBar/Desktop'
import DropdownSort from '@/components/Form/SelectDropdown'
import ListDropdown from '@/components/Dropdown/ListDropdown'
import Modal from '@/components/Modal'
import types from '@/lib/types'
import EmptySelection from '@/components/NotFound/Selection'
import Loading from '@/components/Loading/Primary'
import LoadingSpin from '@/components/Loading/Secondary'
import Pagination from '@/components/Pagination'
import DropdownSearch from '@/components/Dropdown/SearchDropdown'

// Api
import api from '@/api'
import { apiV2 } from '@/api/urls'
import * as validationLib from '@/lib/validation/'
import moment from 'moment'
import { mapGetters, mapActions } from 'vuex';
const {
  helpers,
  validate
} = validationLib

export default {
  name: 'adx-deviceList',
  components: {
    'adx-sidebar': SideBar,
    'adx-dropdown-list': ListDropdown,
    'adx-dropdown-sort': DropdownSort,
    'adx-modal': Modal,
    'adx-empty-selection': EmptySelection,
    'adx-loading': Loading,
    'adx-loading-spin': LoadingSpin,
    'adx-pagination': Pagination,
    'adx-dropdown-search': DropdownSearch,
  },
  data() {
    return {
      selectAll: false,
      isOpen: false,
      sort: [
        {
          'id': 0,
          'label': 'Last Added',
          'value': 'last_added'
        },
        {
          'id': 1,
          'label': 'First Added',
          'value': 'first_added'
        },
        {
          'id': 2,
          'label': 'Name',
          'value': 'name'
        },
      ],
      selectedSortValue: 'last_added',
      searchBoxValue: '',
      selectedRow: null,
      isInit: true,
      isLoading: false,
      isLoadingDelete: false,
      isEmpty: false,
      details: [],
      selectedPage: 1,
      maxPage: 0,
      items: [],
      all_data: [],
      selectedStatusValue: null,
      selectedStatusLabel: null,
      selectedConditionValue: null,
      selectedConditionLabel: null,
      selectedPhotoValue: null,
      selectedPhotoLabel: null,
      locations: [],
      selectedLocationValue: null,
      filterList: [
        {
          id: 0,
          label: 'All Filter',
          value: 'allfilter'
        },
        {
          id: 1,
          label: 'Active',
          value: 'active'
        },
        {
          id: 2,
          label: 'Photo',
          value: 'photo'
        },
        {
          id: 3,
          label: 'Public',
          value: 'public'
        },
      ],
      statusList: [
        {
          id: 0,
          label: 'All',
          value: null
        },
        {
          id: 1,
          label: 'Public',
          value: "True"
        },
        {
          id: 2,
          label: 'Private',
          value: "False"
        },
      ],
      conditionList: [
        {
          id: 0,
          label: 'All',
          value: null
        },
        {
          id: 1,
          label: 'Active',
          value: "True"
        },
        {
          id: 2,
          label: 'Inactive',
          value: "False"
        },
      ],
      photoList: [
        {
          id: 0,
          label: 'All',
          value: null
        },
        {
          id: 1,
          label: 'Have Photo',
          value: "True"
        },
        {
          id: 2,
          label: 'Unset',
          value: "False"
        },
      ]
    }
  },
  computed: {
    filtered: function() {
      let filtered = false
      if (this.selectedPhotoLabel || this.selectedConditionLabel || this.selectedStatusLabel) {
        filtered = true
      }
      return filtered
    },
    getFilterParams: function () {
      const params = {
        sort_by: this.selectedSortValue || undefined,
        search: this.searchBoxValue || undefined,
        photo_exist: this.selectedPhotoValue || undefined,
        active: this.selectedConditionValue || undefined,
        public: this.selectedStatusValue || undefined,
        location: this.selectedLocationValue || undefined
      }
      return params
    },
    ...mapGetters({
      user: 'account',
    })
  },
  watch: {
    searchBoxValue: helpers.debounce(function () {
      this.$nextTick(function () {
        this.selectedPage = 1
        this.initialLoad()
      })
    }, 500),
    selectedStatusValue: function() {
      this.$nextTick(() => {
        this.initialLoad()
      })
    },
    selectedConditionValue: function() {
      this.$nextTick(() => {
        this.initialLoad()
      })
    },
    selectedPhotoValue: function() {
      this.$nextTick(() => {
        this.initialLoad()
      })
    },
    selectedLocationValue: function() {
      this.$nextTick(() => {
        this.initialLoad()
      })
    },
    selectedSortValue: function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.selectedPage = 1
        this.selectedSortValue = newValue
        this.initialLoad()
      }
    }
  },
  beforeCreate() {

  },
  created() {
    this.initialLoad()
  },
  beforeMount() {

  },
  mounted() {
    if (this.$route.query.page) {
      this.selectedPage = this.$route.query.page
    }
    this.initialLoad()
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    initialLoad(isInit = null) {
      (async () => {
        this.isLoading = true
        this.isEmpty = false
        let params = {
          page: this.selectedPage,
          ...this.getFilterParams
        }
        const { data } = await api.get(apiV2.deviceListing, { needToken: true, params })
        if (!data.count) {
          this.isEmpty = true
        }
        this.items = data.results
        this.all_data = data.results
        this.maxPage = data.max_page

        this.getFilter()

        this.$data.isLoading = false
      })();
    },
    duplicateDevices({item}){
      (async () => {
        this.isLoading = true
        let data = {
          pub_id: item.pub_id
        }
        const response = await api.post(apiV2.duplicateDevicesList, data, { needToken: true })
        if(response.status == 201) {
          this.$notify({
            group: 'saved',
            title: 'Success',
            text: `Data successfully duplicated!`,
            type: 'success'
          });
          this.initialLoad()
        } else {
          this.$notify({
            group: 'saved',
            title: 'Error',
            text: response.statusText,
            type: 'danger'
          });
        }
        this.isLoading = false
      })();
    },
    selectPage(item) {
      this.selectedPage = item
      this.initialLoad()
    },
    selectStatus(item) {
      this.selectedStatusLabel = item.label
      this.selectedStatusValue = item.value
    },
    selectCondition(item) {
      this.selectedConditionValue = item.value
      this.selectedConditionLabel = item.label
    },
    selectPhoto(item) {
      this.selectedPhotoValue = item.value
      this.selectedPhotoLabel = item.label
    },
    goToAddNew() {
      this.$router.push({name: 'addnewdevice'})
    },
    goToEdit({item}) {
      let category = `editdevice`
      if (item.pub_id){
          const {pub_id} = item
          this.$router.push({ name: category, params: { pub_id : pub_id } })
        }
    },
    getFilter () {
      (async () => {
        const { data } = await api.get(apiV2.deviceFilters)
        this.locations = data.cities
      })();
    },
    selectedLocation(item){
      this.selectedLocationValue = item.id.toString()
    },
    resetFilter() {
      this.selectedLocationValue = null
      this.selectedStatusLabel = null
      this.selectedStatusValue = null
      this.selectedConditionLabel = null
      this.selectedConditionValue = null
      this.selectedPhotoLabel = null
      this.selectedPhotoValue = null
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>